import { render, staticRenderFns } from "./NewCalculatorUI.vue?vue&type=template&id=40070896&"
import script from "./NewCalculatorUI.vue?vue&type=script&lang=js&"
export * from "./NewCalculatorUI.vue?vue&type=script&lang=js&"
import style0 from "./NewCalculatorUI.vue?vue&type=style&index=0&id=40070896&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports